import a from "classnames";
import { cardSocialLink as v, cardSocialLinkBorder as C, isEditMode as I, icon as m, iconImage as S, textDark as t, textOnAccent as d, iconComponent as E, details as B, title as L, titleDefault as j, titleSmall as A, handle as D, visuallyHidden as F, ctaButton as T, backgroundGrey as G, backgroundWhite as H, ctaIcon as M } from "./CardSocialLink.css.js";
import { getSocialInfo as O } from "../utils/socialHelpers.js";
import { jsxs as b, jsx as i } from "react/jsx-runtime";
import { Icon as w } from "../icon/Icon.js";
function q({
  element: y,
  className: f,
  isEditMode: u,
  children: x
}) {
  var k;
  const {
    customAttributes: $,
    gridProps: {
      sm: l,
      md: c,
      lg: s
    },
    data: e,
    url: p
  } = y, n = O(p), g = !!n.notFound, h = n.networkName === "Email", r = e.title || n.networkName, o = g || h, N = !g || h;
  return /* @__PURE__ */ b("a", {
    ...$,
    href: u ? void 0 : p,
    target: "_blank",
    rel: "noopener noreferrer",
    className: a(v, f, {
      [C]: o,
      [I]: u
    }),
    style: {
      "--grid-column-sm": `${l.x + 1} / span ${l.w}`,
      "--grid-row-sm": `${l.y + 1} / span ${l.h}`,
      "--grid-column-md": `${c.x + 1} / span ${c.w}`,
      "--grid-row-md": `${c.y + 1} / span ${c.h}`,
      "--grid-column-lg": `${s.x + 1} / span ${s.w}`,
      "--grid-row-lg": `${s.y + 1} / span ${s.h}`,
      "--social-link-brand-bg": (k = n.brandBg) != null ? k : n.brandColor
    },
    children: [!N && (e == null ? void 0 : e.icon) ? /* @__PURE__ */ i("img", {
      src: e == null ? void 0 : e.icon,
      alt: n.networkName,
      className: a(m, S)
    }) : null, N && "iconType" in n && "iconName" in n ? /* @__PURE__ */ i(w, {
      type: n.iconType,
      name: n.iconName,
      className: a(m, {
        [t]: o,
        [d]: !o
      }),
      "aria-hidden": !0
    }) : null, !o && "iconComponent" in n ? /* @__PURE__ */ i("div", {
      className: a(m, E),
      children: n.iconComponent
    }) : null, /* @__PURE__ */ b("div", {
      className: B,
      children: [r ? /* @__PURE__ */ i("h3", {
        className: a(L, {
          [t]: o,
          [d]: !o,
          [j]: (r == null ? void 0 : r.length) <= 10,
          [A]: (r == null ? void 0 : r.length) > 10
        }),
        children: r
      }) : null, e.username && /* @__PURE__ */ i("p", {
        className: a(D, {
          [t]: o,
          [d]: !o
        }),
        children: e.username
      })]
    }), /* @__PURE__ */ i("div", {
      className: F,
      children: x
    }), /* @__PURE__ */ i("div", {
      className: a(T, {
        [G]: o,
        [H]: !o
      }),
      style: {
        color: n.brandColor
      },
      children: /* @__PURE__ */ i(w, {
        type: "bx",
        name: "right-arrow-alt",
        className: a(M, {
          [t]: o
        }),
        "aria-hidden": !0
      })
    })]
  });
}
export {
  q as CardSocialLinkElement
};
